import { render, staticRenderFns } from "./indexElective.vue?vue&type=template&id=5649ef91&scoped=true"
import script from "./indexElective.vue?vue&type=script&lang=js"
export * from "./indexElective.vue?vue&type=script&lang=js"
import style0 from "./indexElective.vue?vue&type=style&index=0&id=5649ef91&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649ef91",
  null
  
)

export default component.exports